export default {
  path: '/manage',
  title: '系统管理',
  icon: 'sliders',
  children: [
    {
      path: 'permission',
      title: '角色权限',
      icon: 'shield',
      component: 'manage/role'
    },
    {
      path: 'staff',
      title: '员工管理',
      icon: 'user',
      component: 'manage/staff'
    }
  ]
}
